import React from 'react'
import styled from 'styled-components'
import Modal from './Modal'
import themes from 'themes'

const getFolders = concept => themes[concept].kiosks_background || {}

const PicturePicker = ({
    open,
    concept = 'stdr',
    handleChange,
    close,
    excel,
    useCommercialName,
}) => {
    let index, name
    const type = excel ? 'kiosk_' : 'recipe_'
    if (excel) {
        index = open && open.index
        name = open && open.name
    }
    return !open ? null : (
        <Modal>
            <Shade>
                <Segment>
                    <Header>
                        Pictures available for the concept {concept}
                        <CloseButton onClick={close}>x</CloseButton>
                    </Header>
                    <div className="body">
                        {Object.keys(getFolders(concept)).map((kiosk, i) => (
                            <div
                                style={{ position: 'relative' }}
                                key={i}
                                onClick={e => {
                                    e.target.name = `${type}${
                                        excel ? index : open
                                    }-${kiosk}`
                                    e.target.type = 'checkbox'
                                    e.target.checked = true
                                    handleChange(e)
                                    close()
                                }}
                            >
                                <KioskHeader>
                                    <img
                                        src={`img/concept/${concept}/kiosk/${kiosk}/header.png?_=9edb01b`}
                                    />
                                    {useCommercialName ? null : (
                                        <span>
                                            <img
                                                src={`img/concept/${concept}/kiosk/${kiosk}/logo.png?_=9edb01b`}
                                            />
                                        </span>
                                    )}
                                </KioskHeader>
                            </div>
                        ))}
                    </div>
                </Segment>
            </Shade>
        </Modal>
    )
}

export default PicturePicker

export const CloseButton = styled.button`
    background-color: #fff;
    border-radius: 50%;
    color: rgb(105, 105, 105);
    border: 1px solid rgb(105, 105, 105);
    height: 20px;
    width: 20px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-right: 20px;
    outline: none;
`

const KioskHeader = styled.div`
    padding-top: 12px;
    margin-bottom: 15px;
    cursor: pointer;
    opacity: 0.6;
    transition: all 0.5s;
    &:hover{
        opacity:1
        transform: scale(1.05);
    }
    img {
        height: 95px;
        width: 100%;
        object-fit: cover;
    }
    span img {
        position: absolute;
        left: 25px;
        top: 0;
        width: auto;
        height: 107px;
    }
`

const Header = styled.h2`
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgb(105, 105, 105);
    font-weight: normal;
    margin: 0;
    padding: 10px;
    height: 50px;
    background-color: #fff;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
`

const Segment = styled.div`
    background-color: #fff;
    position: relative;
    min-height: 90vh;
    max-height: 90vh;
    height: 90vh;
    box-shadow: 0px 0px 15px 2px rgba(0, 0, 0, 0.75);
    border-radius: 5px;
    padding-top: 0px !important;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .body {
        padding: 20px;
        position: relative;
        overflow-y: auto !important;
        overflow-x: hidden !important;
    }

    /* Modal Width */
    @media only screen and (max-width: 767px) {
        width: 95%;
        margin: 0em 0em 0em 0em;
        .body {
            padding: 10px;
        }
    }
    @media only screen and (min-width: 768px) {
        width: 88%;
        margin: 0em 0em 0em 0em;
        .body {
            padding: 15px;
        }
    }
    @media only screen and (min-width: 992px) {
        width: 850px;
        margin: 0em 0em 0em 0em;
    }
    @media only screen and (min-width: 1200px) {
        width: 900px;
        margin: 0em 0em 0em 0em;
    }
    @media only screen and (min-width: 1920px) {
        width: 950px;
        margin: 0em 0em 0em 0em;
    }
    opacity: 1;
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 0.2s;

    @keyframes fadeInOpacity {
        0% {
            opacity: 0;
            transform: scale(0.8);
        }
        100% {
            opacity: 1;
            transform: scale(1);
        }
    }
`
const Shade = styled.div`
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1000000;
    display: flex;
    justify-content: center;
    align-items: center;
`
